import { Component, Input, Output, EventEmitter } from '@angular/core';
import { PlanCoordinate } from '../../../services/plan-coordinate';

@Component({
  selector: 'app-edit-overlay',
  templateUrl: './edit-overlay.component.html',
  styleUrls: ['./edit-overlay.component.scss']
})
export class EditOverlayComponent {
  @Input() targetCoordinate: PlanCoordinate;
  @Input() isPlaceholder: boolean;
  @Input() isEditor: boolean;
  @Output() planCoordinateChange = new EventEmitter<PlanCoordinate>();

  onEditClick() {
    if (this.isEditor) {
      this.planCoordinateChange.emit(this.targetCoordinate);
    }
  }

  get overlayClass() {
    return `edit-overlay ${this.isPlaceholder ? 'stay-visible' : ''} ${this.isEditor ? 'editor' : ''}`;
  }

}
